import React from 'react'
import { openModal } from 'components/Modal/actions'
import { isEmpty } from 'lodash'

export default function Footer({
  labels,
  platform = { version: '', changelog: '' },
  components = { version: '', changelog: '' },
  product = { version: '', changelog: '' },
  id
}) {
  const { versionsLabel, platformLabel, componentsLabel, productLabel } = labels

  const onOpenChangelog = (libraryName, libraryVersion, urlChangelog) => {
    openModal('changelog', {
      urlChangelog: urlChangelog,
      libraryName,
      libraryVersion
    })
  }

  return (
    <div className='settings-footer' id={id}>
      <h6>{versionsLabel}</h6>
      <div className='footer-section'>
        {!isEmpty(platform.version) && (
          <span>
            <span className='footer-subtitle'>{platformLabel}</span>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() =>
                onOpenChangelog(
                  platformLabel,
                  platform.version,
                  platform.changelog
                )
              }
            >
              {platform.version}
            </span>
          </span>
        )}
        {isEmpty(platform.version) && (
          <span className='footer-subtitle'>Need update product</span>
        )}
        {!isEmpty(components.version) && (
          <span>
            <span className='footer-subtitle'>{componentsLabel}</span>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() =>
                onOpenChangelog(
                  componentsLabel,
                  components.version,
                  components.changelog
                )
              }
            >
              {components.version}
            </span>
          </span>
        )}
        {isEmpty(components.version) && (
          <span className='footer-subtitle'>Need update product</span>
        )}
        {!isEmpty(product.version) && (
          <span>
            <span className='footer-subtitle'>{productLabel}</span>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() =>
                onOpenChangelog(
                  productLabel,
                  product.version,
                  product.changelog
                )
              }
            >
              {product.version}
            </span>
          </span>
        )}
      </div>
    </div>
  )
}
